import { render, staticRenderFns } from "./vehicle_engine_speed_compare_data.vue?vue&type=template&id=b3e2aa88&scoped=true"
import script from "./vehicle_engine_speed_compare_data.vue?vue&type=script&lang=js"
export * from "./vehicle_engine_speed_compare_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e2aa88",
  null
  
)

export default component.exports